import { Box, HStack } from '@chakra-ui/react';

import Text from './Text';

interface FilterOption {
  label: string;
  value: string;
}

interface DifficultyPillsProps {
  options: FilterOption[];
  selected: string;
  onChange: (value: string) => void;
}

const DifficultyPills = ({ options, selected, onChange }: DifficultyPillsProps) => {
  return (
    <HStack spacing={2} flexWrap="wrap">
      {options.map(({ label, value }) => {
        const isActive = selected === value;

        return (
          <Box
            key={value}
            as="button"
            px={3}
            py={1}
            borderRadius="full"
            bg={isActive ? 'rgba(159, 122, 234, 0.2)' : 'whiteAlpha.100'}
            color={isActive ? 'purple.200' : 'whiteAlpha.600'}
            fontSize="sm"
            fontWeight="medium"
            cursor="pointer"
            transition="all 0.15s"
            _hover={isActive ? {} : { bg: 'whiteAlpha.200' }}
            onClick={() => onChange(value)}
          >
            <Text fontSize="small" fontWeight="medium" color="inherit">
              {label}
            </Text>
          </Box>
        );
      })}
    </HStack>
  );
};

export default DifficultyPills;
